module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "bk-title"
  }, [_c('a', {
    attrs: {
      "id": "piii"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" "), _c('br'), _vm._v("Sorcerer’s "), _c('br'), _vm._v("Apprentice")]), _vm._v(" "), _c('p', {
    staticClass: "bk-subtitle"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("AN ANTHOLOGY")]), _vm._v(" "), _c('i', [_vm._v("of")]), _vm._v(" "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("MAGICAL TALES")])]), _vm._v(" "), _c('p', {
    staticClass: "bk-edition"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("EDITED BY")])]), _vm._v(" "), _c('p', {
    staticClass: "bk-author"
  }, [_vm._v("Jack Zipes")]), _vm._v(" "), _c('p', {
    staticClass: "bk-author1"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("ILLUSTRATED BY NATALIE FRANK")])]), _vm._v(" "), _c('p', {
    staticClass: "BK-pub"
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("PRINCETON UNIVERSITY PRESS")])]), _vm._v(" "), _c('p', {
    staticClass: "BK-pub1"
  }, [_c('i', [_vm._v("Princeton & Oxford")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26d878a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/title_page.vue
// module id = 63
// module chunks = 0